import { StyleSheet } from 'react-native';

import { buttonStyles } from '../components/buttons';
import { cardStyles } from '../components/cards';
import { colors, spacing, layout, container } from '../theme';

// Styles for association list screens
export const associationListStyles = StyleSheet.create({
	container: {
		...container.screen,
	},
	item: {
		...cardStyles.card,
	},
	fab: {
		...buttonStyles.fab,
	},
	emptyContainer: {
		padding: spacing.xl,
		alignItems: 'center',
		justifyContent: 'center',
	},
});

// Styles for association detail screens
export const associationDetailStyles = StyleSheet.create({
	container: {
		flex: 1,
		padding: spacing.m,
		backgroundColor: colors.background,
	},
	title: {
		marginBottom: spacing.m,
		fontWeight: 'bold',
	},
	detailsContainer: {
		marginBottom: spacing.l,
	},
	contactContainer: {
		marginBottom: spacing.l,
	},
	divider: {
		marginVertical: spacing.m,
	},
	workOrdersHeader: {
		flexDirection: 'row',
		justifyContent: 'space-between',
		alignItems: 'center',
		marginBottom: spacing.m,
	},
	workOrderCard: {
		backgroundColor: colors.card,
		padding: spacing.m,
		borderRadius: layout.borderRadius.medium,
		marginBottom: spacing.s,
		borderLeftWidth: 4,
		borderLeftColor: colors.primary,
	},
	statusContainer: {
		flexDirection: 'row',
		marginTop: spacing.xs,
	},
	statusText: {
		fontSize: 12,
		backgroundColor: colors.primary,
		color: 'white',
		paddingHorizontal: spacing.s,
		paddingVertical: spacing.xs,
		borderRadius: layout.borderRadius.small,
		marginRight: spacing.s,
	},
	priorityText: {
		fontSize: 12,
		backgroundColor: colors.secondary,
		color: 'white',
		paddingHorizontal: spacing.s,
		paddingVertical: spacing.xs,
		borderRadius: layout.borderRadius.small,
	},
	description: {
		marginTop: spacing.s,
		opacity: 0.7,
	},
	emptyText: {
		textAlign: 'center',
		marginTop: spacing.xl,
		opacity: 0.6,
	},
	button: {
		marginTop: spacing.m,
	},
});
